export default Object.freeze({
    Municipality: "level.municipality",
    Region: "level.region",
    District: "level.district",
    Center: "level.center",
    School: "level.school",
    Company: "level.company",
    CompanySpecialist: "level.companySpecialist",
    Student: "level.student"
});